module.exports = __webpack_public_path__ + "img/base_contrato.14510586.jpg";